import react from 'react';

import pdf from './paper.pdf';

export default function Paper() {
    const link = document.createElement('a');
    link.href = pdf;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}